export default function Field({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  options,
  required,
}: {
  label: string;
  type?: string;
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  options?: (string | { label: string; value: string })[];
  required?: boolean;
}) {
  return (
    <div>
      <label
        className="block text-[12px] text-slate-600 mb-1.5"
        style={{ fontFamily: "Inter, sans-serif", fontWeight: 600 }}
      >
        {label}
      </label>
      {type === "select" ? (
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className="w-full px-4 py-3 rounded-2xl border border-slate-200 bg-white text-slate-800 text-[13px] outline-none focus:border-violet-400 focus:ring-2 focus:ring-violet-100 transition-all"
        >
          {options?.map((opt, i) => {
            const isObj = typeof opt === "object";
            const val = isObj ? opt.value : opt;
            const label = isObj ? opt.label : opt;
            return (
              <option key={val + "-" + i} value={val}>
                {label}
              </option>
            );
          })}
        </select>
      ) : (
        <input
          type={type}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full px-4 py-3 rounded-2xl border border-slate-200 bg-white text-slate-800 text-[13px] outline-none focus:border-violet-400 focus:ring-2 focus:ring-violet-100 transition-all placeholder-slate-400"
          required={required}
        />
      )}
    </div>
  );
}
